const selectButtons = [
    { id: '1', label: 'HTML', quiz:'html', status:'Uncompleted'},
    { id: '2', label: 'CSS', quiz:'css', status:'Uncompleted'},
    { id: '3', label: 'JavaScript' , quiz:'javascript', status:'Uncompleted'},
    { id: '4', label: 'React.js' , quiz:'react', status:'Uncompleted'},
    { id: '5', label: 'Node.js' , quiz:'node', status:'Uncompleted'},
    { id: '6', label: 'Data structures' , quiz:'data', status:'Uncompleted'},
    { id: '7', label: 'Algorithms' , quiz:'algorithms', status:'Uncompleted'},
  ];

  export default selectButtons